import { getDateFormats } from "app/dateFormats";
import { format } from "date-fns";

export default (rawDate) => {
  return format(new Date(rawDate), getDateFormats().dateTime);
};
